
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/homegrown",
      function () {
        return require("private-next-pages/brand/homegrown.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/homegrown"])
      });
    }
  